/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { fg } from '@atlassian/jira-feature-gating';

import { performGetRequest, performPutRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export type UserPropertiesApiResponse<T> = {
	key: string;
	value: T;
};

const getUserUrl = (accountId: string, propertyKey: string) =>
	`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;

export const setUserProperty = async <T,>({
	accountId,
	propertyKey,
	propertyValue,
}: {
	accountId: string;
	propertyKey: string;
	propertyValue: T;
}): Promise<void> => {
	const url = getUserUrl(accountId, propertyKey);

	try {
		await performPutRequest(url, {
			body: JSON.stringify(propertyValue),
		});
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: `SET_${propertyKey}`,
				packageName: 'jiraCrossJoinNudges',
			},
			error,
		});
	}
};

export const getUserProperty = async <T,>({
	accountId,
	propertyKey,
	defaultValue,
}: {
	accountId: string;
	propertyKey: string;
	defaultValue: T;
}): Promise<UserPropertiesApiResponse<T>> => {
	const url = getUserUrl(accountId, propertyKey);
	if (fg('PUMA-1625-fix-cjn-value-sentry-errors')) {
		let response: UserPropertiesApiResponse<T> | null;
		try {
			response = await performGetRequest(url);
		} catch (_ignoredError) {
			response = null;
		}
		return response ?? { key: propertyKey, value: defaultValue };
	}
	try {
		const response: UserPropertiesApiResponse<T> = await performGetRequest(url);
		return response;
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		return { key: propertyKey, value: defaultValue };
	}
};
